<div class="flex gap-10">
  <app-date-picker-padrao [label]="labelData" [placeholder]="'Selecione'" [data]="dataSelecionada" [dataMinima]="dataMinima" [disabled]="disabledData" (envioDataSelecionada)="dataSelecionada = $event; tratarTempo(true)"></app-date-picker-padrao>
  <app-time-picker-padrao [tempo]="horarioSelecionado" [disabled]="disabledHorario" (envioHorarioSelecionado)="horarioSelecionado = $event; tratarTempo()"></app-time-picker-padrao>
</div>
